import $ from 'jquery';

export default function init( pluginApi ) {

  pluginApi.addFilter( 'reader_disable_page_flip', 'asmag_reader_plugin', ( disable, issue ) => {
    // Disable IssueReader page flip when a PhotoSwipe gallery is open
    if ( $( ".ps-carousel" ).length )
      return true;

    return disable;
  } );

}
